import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { paths } from '../../../../app/routes'
import EntityCard from './Subcomponents/EntityCard'
import Style from '../details.module.css'
const mergeEntities = (sourceEntity, targetEntity) => {
    const merged = sourceEntity.map((source) => {
        const match = targetEntity.find((target) => target.entityName === source.entityName)
        return {
            entityName: source.entityName,
            sourceCount: source.totalCount,
            targetCount: match ? match.totalCount : 0
        }
    })

    const targetOnly = targetEntity
        .filter((target) => !sourceEntity.some((source) => source.entityName === target.entityName))
        .map((target) => ({
            entityName: target.entityName,
            sourceCount: 0,
            targetCount: target.totalCount
        }))

    return merged.concat(targetOnly)
}

const EMPTY = []
const BusinessEntities = (props) => {
    const sourceEntity = props.businessEntitiesSource || EMPTY
    const targetEntity = props.businessEntitiesTarget || EMPTY

    const entities = useMemo(
        () => mergeEntities(sourceEntity, targetEntity),
        [sourceEntity, targetEntity]
    )

    return (
        <>
            <div className={`card-header ${Style.cardHeader}`}>
                <div className={Style.cardHeaderTitle}>
                    <span>Business Entities</span>
                    <span className={Style.countChip}>{entities.length}</span>
                </div>
                {entities.length === 0 ? (
                    <button type="button" className={Style.linkButton} disabled title="Installation setup is incomplete">
                        View Details <i className="uil-angle-right" aria-hidden="true" />
                    </button>
                ) : (
                    <Link className={Style.linkButton} to={paths.viewSummary(props.connectorId)} title="View entity summary">
                        View Details <i className="uil-angle-right" aria-hidden="true" />
                    </Link>
                )}
            </div>

            <div className={`card-body ${Style.entityBody}`}>
                {entities.length === 0 ? (
                    <div className={Style.emptyState}>
                        <i className={`uil-database ${Style.emptyIcon}`} aria-hidden="true" />
                        <p className={Style.emptyText}>No business entities yet</p>
                        <p className={Style.emptyHint}>They appear once the connector setup is complete.</p>
                    </div>
                ) : (
                    <div className="row">
                        {entities.map((entity) => (
                            <EntityCard
                                key={entity.entityName}
                                entityName={entity.entityName}
                                sourceCount={entity.sourceCount}
                                targetCount={entity.targetCount}
                                sourceShortName={props.sourceShortName}
                                targetShortName={props.targetShortName}
                            />
                        ))}
                    </div>
                )}
            </div>
        </>
    )
}

export default BusinessEntities
